import React, { useCallback, useMemo, useState } from 'react';
import { DatePicker as MuiDatePicker } from '@mui/x-date-pickers/DatePicker';

export default function AutoOpenDatePicker(props) {
    const { open: openProp, onOpen, onClose, slotProps, ...rest } = props;
    const isControlled = openProp !== undefined;
    const [openState, setOpenState] = useState(false);

    const handleOpen = useCallback(
        event => {
            if (rest.disabled || rest.readOnly) return;
            if (onOpen) onOpen(event);
            if (!isControlled) setOpenState(true);
        },
        [isControlled, onOpen, rest.disabled, rest.readOnly]
    );

    const handleClose = useCallback(
        event => {
            if (onClose) onClose(event);
            if (!isControlled) setOpenState(false);
        },
        [isControlled, onClose]
    );

    const mergedSlotProps = useMemo(() => {
        const textFieldProps = slotProps?.textField || {};
        const fieldProps = slotProps?.field || {};
        const wrapOnClick = original => event => {
            if (original) original(event);
            handleOpen(event);
        };
        return {
            ...slotProps,
            textField: {
                ...textFieldProps,
                onClick: wrapOnClick(textFieldProps.onClick),
            },
            field: {
                ...fieldProps,
                onClick: wrapOnClick(fieldProps.onClick),
            },
        };
    }, [handleOpen, slotProps]);

    return (
        <MuiDatePicker
            {...rest}
            open={isControlled ? openProp : openState}
            onOpen={handleOpen}
            onClose={handleClose}
            slotProps={mergedSlotProps}
        />
    );
}
